import { Expose, plainToClass, Serializable, Transform, Type } from '@tokeet/tv3-platform'
import { IBookingEngineCost } from '@tv3/interfaces/responses/booking-engine-cost.response'
import * as lodash from 'lodash'
import { AuditDiscount, BookingEngineBookingFee, BookingEngineTax } from '@tokeet/cost-resolver'
import { BookingEngineAuditDay } from '@tokeet-frontend/bookings'

function normalizeNumber(v) {
  return lodash.toNumber(v) || 0
}

export class BookingEngineCost extends Serializable<BookingEngineCost> {
  @Transform((value) => lodash.map(value, (t) => ({ ...t, amount: normalizeNumber(t.amount) })), {
    toClassOnly: true,
  })
  taxes: BookingEngineTax[]

  @Expose({ name: 'ratecategory' })
  rateCategory: string

  @Expose({ name: 'discounttotal' })
  @Transform((value) => normalizeNumber(value), { toClassOnly: true })
  discountTotal: number

  @Expose({ name: 'taxpercent' })
  taxPercent: number

  @Expose({ name: 'extraguests' })
  @Transform((value) => normalizeNumber(value), { toClassOnly: true })
  extraGuests: number

  extraBedrooms: number

  @Expose({ name: 'taxtotal' })
  @Transform((value) => normalizeNumber(value), { toClassOnly: true })
  taxTotal: number

  minimumstay: number | null
  maximumstay: number | null

  sleep_min: number | null
  maxguests: number | null

  @Expose({ name: 'discountfees' })
  @Type(() => DiscountFee)
  @Transform((value) => (lodash.isNumber(value) ? { amount: value } : value), { toClassOnly: true })
  discountFees: DiscountFee[]

  @Expose({ name: 'auditdiscount' })
  @Transform((v) => lodash.map(v, (t) => ({ ...t, disc_amount: normalizeNumber(t.disc_amount) })))
  auditDiscounts: AuditDiscount[]

  @Transform((value) => normalizeNumber(value), { toClassOnly: true })
  bookfeestotal: number

  @Expose({ name: 'bookingfees' })
  @Transform((v) => lodash.map(v, (t) => ({ ...t, amount: normalizeNumber(t.amount) })))
  bookingFees: BookingEngineBookingFee[]

  auditdays?: BookingEngineAuditDay[]

  @Transform((value, obj) => normalizeNumber(value), { toClassOnly: true })
  base: number

  @Transform((value) => normalizeNumber(value), { toClassOnly: true })
  total: number

  extraBedroomsBase: number

  static deserialize(data: IBookingEngineCost): BookingEngineCost {
    const engineCost: BookingEngineCost = plainToClass(BookingEngineCost, data)
    engineCost.extraBedrooms = getExtraBedroomsFee(engineCost.auditdays)
    engineCost.extraBedroomsBase = engineCost.base - engineCost.extraBedrooms
    return engineCost
  }
}

export function getExtraBedroomsFee(items: BookingEngineAuditDay[]): number {
  return lodash.sumBy(items, (item: BookingEngineAuditDay) => +(item.booking_occupancy?.bedroom_adjustment || 0) || 0)
}

export class DiscountFee {
  amount: number
}
